var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.fields.temoignages),function(temoignage,i){return _c('div',{key:i,staticClass:"temoignages"},[_c('prismic-rich-text',{staticClass:"temoignages",attrs:{"field":temoignage.temoignage}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }